<template>
  <div class="row col-12">
    <div class="q-mt-xl col-md col-xs-12 col-sm-12 q-mr-xs">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Pessoas que precisam fazer esse treinamento
        </span>
        <div
          class="row col-12 justify-end text-brand-5 text-weight-bold q-mb-sm container-input-search"
        >
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            type="text"
            v-model="buscaAssociados"
            class="col-md-5 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-table
        :columns="columns"
        :rows="selected"
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        flat
        dense
        class="tabela-tamanho-fixo"
        :grid="$q.screen.lt.sm"
        :rows-per-page-options="[0]"
        row-key="funcionarioId"
        :pagination="initialPagination"
        :filter="buscaAssociados"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-8">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Nome: </strong>
                    {{ props.row.funcionarioNome }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">ID: </strong>
                    {{ props.row.sap }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Data Realização: </strong>
                    <span v-if="props.row?.dataRealizacao != null">
                      {{
                        props.row?.dataRealizacao.split("-").reverse().join("/")
                      }}</span
                    ></span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Vence Em: </strong>
                    <span v-if="props.row?.dataExpiracao != null">
                      {{
                        props.row?.dataExpiracao.split("-").reverse().join("/")
                      }}</span
                    ></span
                  >
                </div>
                <div class="col-4">
                  <div class="row col-12 justify-end">
                    <q-btn
                      icon="cancel"
                      round
                      color="red"
                      size="lg"
                      flat
                      @click="desassociarPessoa(props.row.funcionarioId)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.funcionarioNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-id="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.sap }}
          </q-td>
        </template>
        <template v-slot:body-cell-ultimaRealizacao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span v-if="props?.row.dataRealizacao != null">
              {{
                props.row?.dataRealizacao.split("-").reverse().join("/")
              }}</span
            >
          </q-td>
        </template>
        <template v-slot:body-cell-venceEm="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span v-if="props?.row.dataExpiracao != null">
              {{
                props.row?.dataExpiracao.split("-").reverse().join("/")
              }}</span
            >
          </q-td>
        </template>
        <template v-slot:body-cell-obrigatorio="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.obrigatorio == 0 ? "Não" : "Sim" }}
          </q-td>
        </template>
        <template v-slot:body-cell-remover="props">
          <q-td :props="props">
            <q-btn
              icon="cancel"
              round
              color="red"
              flat
              :disable="disable"
              @click="desassociarPessoa(props.row)"
            />
          </q-td>
        </template>
      </q-table>
    </div>
    <div class="q-mt-xl col-md col-xs-12 col-sm-12">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Associar Novas pessoas
        </span>
        <div
          class="row col-12 justify-end text-brand-5 text-weight-bold q-mb-sm container-input-search"
        >
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            type="text"
            v-model="busca"
            class="col-md-5 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-table
        :columns="columns2"
        :rows="disponiveis.data"
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        class="tabela-tamanho-fixo"
        row-key="id"
        selection="single"
        dense
        v-model:selected="selected"
        :grid="$q.screen.lt.sm"
        hide-pagination
        v-model:pagination="pagination"
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-8">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Nome: </strong>
                    {{ props.row.name }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">ID: </strong>
                    {{ props.row.sap }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Email: </strong>
                    {{ props.row.email }}</span
                  >
                  <span
                    v-if="!props.selected"
                    class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Obrigatório: </strong>
                    <input
                      style="height: 19px; width: 19px; margin-left: 5px"
                      type="checkbox"
                      v-model="props.row.obrigatorio"
                  /></span>
                </div>
                <div class="col-4">
                  <div class="row col-12 justify-end">
                    <q-btn
                      :disable="props.selected"
                      icon="add_circle"
                      :color="props.selected ? 'light-green-4' : 'positive'"
                      round
                      flat
                      size="lg"
                      @click="associarPessoa(props.row)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :style="props.selected ? 'background: #EFF5F5' : ''"
            class="text-brand-5 text-weight-bold"
          >
            <q-td>
              <span> {{ props.row.name }}</span>
            </q-td>
            <q-td>
              <span> {{ props.row.sap }}</span>
            </q-td>
            <q-td>
              <span> {{ props.row.email }}</span>
            </q-td>
            <q-td>
              <input
                style="height: 20px; width: 20px; margin-left: 20px"
                type="checkbox"
                v-model="props.row.obrigatorio"
                v-if="!props.selected"
              />
            </q-td>
            <q-td>
              <q-btn
                :disable="props.selected"
                icon="add_circle"
                :color="props.selected ? 'light-green-4' : 'positive'"
                round
                flat
                @click="associarPessoa(props.row)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { watch, ref, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
    field: "funcionarioNome",
  },
  {
    name: "id",
    label: "ID",
    align: "left",
    field: "sap",
  },
  {
    name: "ultimaRealizacao",
    label: "Última Realização",
    align: "left",
  },
  {
    name: "venceEm",
    label: "Vence Em",
    align: "left",
  },
  {
    name: "obrigatorio",
    label: "Obrigatório",
    align: "left",
  },
  {
    name: "remover",
    label: "Remover",
    align: "center",
  },
];
const columns2 = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "id",
    label: "ID",
    align: "left",
  },
  {
    name: "email",
    label: "Email",
    align: "left",
  },
  {
    name: "obrigatorio",
    label: "Obrigatório",
    align: "left",
  },
  {
    name: "adicionar",
    label: "Adicionar",
    align: "center",
  },
];
export default {
  props: ["selecionados", "disponiveis", "treinamentoId"],
  emits: ["buscar", "paginarTabela", "atualizarTabela"],
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();

    const selected = ref([]);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: props.disponiveis.per_page,
      rowsNumber: props.disponiveis.total,
    });
    let loading = ref(false);
    let disable = ref(false);
    const busca = ref("");
    const buscaAssociados = ref("");

    const associarPessoa = async (row) => {
      let obrigatorio = false;
      if (row.obrigatorio) {
        obrigatorio = row.obrigatorio;
      }
      try {
        await store.dispatch("treinamento/associarPessoa", {
          treinamentoId: props.treinamentoId,
          id: row.id,
          obrigatorio: obrigatorio,
        });
        quasar.notify({
          message: "Pessoa associada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("atualizarTabela");
        loading.value = true;
        disable.value = true;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao associar pessoa",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const desassociarPessoa = async (row) => {
      try {
        await store.dispatch("treinamento/desassociarPessoa", {
          treinamentoId: props.treinamentoId,
          id: row.id,
        });
        quasar.notify({
          message: "Pessoa desassociada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("atualizarTabela");
        loading.value = true;
        disable.value = true;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao desassociar pessoa",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberPessoas = () => {
      selected.value = [];
      props.selecionados.forEach((selecionado) => {
        selected.value.push({
          dataExpiracao: selecionado.dataExpiracao,
          dataRealizacao: selecionado.dataExpiracao,
          sap: selecionado.matricula,
          id: selecionado.funcionarioId,
          funcionarioNome: selecionado.funcionarioNome,
          obrigatorio: selecionado.obrigatorio,
          treinamentoId: selecionado.treinamentoId,
          validade: selecionado.validade,
        });
      });
    };

    watch(
      () => props.selecionados,
      () => {
        receberPessoas();
      }
    );

    watch(
      () => props.disponiveis,
      () => {
        pagination.value.rowsPerPage = props.disponiveis.per_page;
        pagination.value.page = props.disponiveis.current_page;
        pagination.value.rowsNumber = props.disponiveis.total;
        disable.value = false;
        loading.value = false;
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        emit(
          "paginarTabela",
          pagination.value.page,
          pagination.value.rowsPerPage
        );
        disable.value = true;
        loading.value = true;
      }
    );

    watch(
      () => busca.value,
      () => {
        emit("buscar", busca.value);
      }
    );

    return {
      columns,
      columns2,
      selected,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      initialPagination: {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 20,
      },
      disable,
      loading,
      busca,
      associarPessoa,
      receberPessoas,
      desassociarPessoa,
      buscaAssociados,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}
tbody tr td {
  white-space: pre-wrap;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }

  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }

  .input {
    font-size: 12px;
  }
  .btn {
    margin: 0px 0px 0px 0px;
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .mobile {
    display: none;
  }
}
</style>
